import React from 'react'
import { ExternalLink } from 'lucide-react'
import { HealthInstitution } from '../types/HealthInstitution'
import { DDGColors } from '../constants/colors'

interface ReturnToFacilityLinkProps {
	activeFacility: HealthInstitution | null
}

// Card payments break out of the embed iframe to the top-level browsing
// context for the redirect (payment/3DS pages generally refuse to be
// framed), so the success screen can land outside the facility's site.
// Only show this when we're actually at the top level — inside the iframe
// the user is already looking at the facility's site around us.
const ReturnToFacilityLink: React.FC<ReturnToFacilityLinkProps> = ({
	activeFacility,
}) => {
	const website = activeFacility?.details?.website
	const isTopLevel = typeof window !== 'undefined' && window.self === window.top
	if (!website || !isTopLevel) return null

	const href = website.startsWith('http') ? website : `https://${website}`

	return (
		<a
			href={href}
			className='flex items-center justify-center gap-1 py-3 text-xs font-semibold text-primary'
		>
			Return to {activeFacility?.details.institutionName}
			<ExternalLink size={12} color={DDGColors.primary} />
		</a>
	)
}

export default ReturnToFacilityLink
